import AddRequest from "../common/AddRequest.js";
import {TraderProvider} from "./TraderContext.js";
import {AdminProvider} from "../admin/AdminContext.js";
export default function TraderPage() {
  return (
    <AdminProvider>
      <TraderProvider>
        <AddRequest />
      </TraderProvider>
    </AdminProvider>
  );
}